import cn from 'classnames';

const CSS_UID = 'field-input-number-24qsdfssfg4-00f8-4e7b-8825-dd064f4176a9';

/**
 *  add class name
 * @param {*} param0
 */
export const addClassName = ({ existError, showError }) =>
  cn(CSS_UID, {
    exist_error_style: existError,
    show_error_style: showError,
    valid_style: !existError && !showError,
  });
